
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PriceErrorDisplayProps {
  onRetry?: () => void;
  errorMessage?: string;
}

export function PriceErrorDisplay({ onRetry, errorMessage = "Impossibile caricare i prezzi. Riprova più tardi." }: PriceErrorDisplayProps) {
  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Errore</AlertTitle>
      <AlertDescription className="flex justify-between items-center">
        <span>{errorMessage}</span>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry} className="ml-2">
            <RefreshCw className="h-3 w-3 mr-1" />
            Riprova
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
}
